import { useMemo, useState } from "react";
import {
  applyTableFilters,
  buildFieldOptions,
  computeFilterMetrics,
  countActiveFilters,
  getActiveFilterChips,
  getInitialFilters,
} from "../utils/tableFilters";

export default function useTableFilters(data, config, initialFilters) {
  const [filters, setFilters] = useState(() => ({
    ...getInitialFilters(config),
    ...(initialFilters ?? {}),
  }));
  const [drawerOpen, setDrawerOpen] = useState(false);

  const fieldOptions = useMemo(
    () => buildFieldOptions(data, config.fields),
    [data, config.fields]
  );

  const filtered = useMemo(
    () => applyTableFilters(data, filters, config),
    [data, filters, config]
  );

  const metrics = useMemo(
    () => computeFilterMetrics(filtered, data, config.metrics),
    [filtered, data, config.metrics]
  );

  const activeCount = useMemo(
    () => countActiveFilters(filters, config),
    [filters, config]
  );

  const activeChips = useMemo(
    () => getActiveFilterChips(filters, config, fieldOptions),
    [filters, config, fieldOptions]
  );

  const setFilter = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const resetFilters = () => setFilters(getInitialFilters(config));

  const removeFilter = (key) => {
    if (key === "search") {
      setFilter("search", "");
      return;
    }
    const field = config.fields?.find((f) => f.key === key);
    if (!field) return;
    setFilter(key, getInitialFilters({ fields: [field] })[key]);
  };

  return {
    filtered,
    filters,
    setFilter,
    setFilters,
    resetFilters,
    removeFilter,
    activeCount,
    activeChips,
    metrics,
    drawerOpen,
    setDrawerOpen,
    fieldOptions,
  };
}
